/**
 * Created by eatin on 2017/11/20.
 */
import {appDomain, domain, imgDomain} from "./env"
import {getWxJsSdkConfig} from "@/api/api"

export default {

  /**
   * 判断环境
   * @returns {string} = ['web'|'android'|'ios']
   */
  getEnv(){
    const u = navigator.userAgent;

    // web端调试
    if(u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger' || u.toLowerCase().match(/_SQ_/i) == '_sq_') return 'web'

    // Android终端
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    if (isAndroid) return 'android'

    // iOS终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) return 'ios'

    // web端调试
    return 'web'
  },

  // 判断平台
  getPlatform(){

    let APP_HEAD_PROTOCOL = 'mfhapp'     // 魔方屋
    let APP_HEAD_PROTOCOL_2 = 'ydapp'    // 易道导购 (原"易道AI设计")

    let ua = navigator.userAgent,
      windowsPhone = /(?:Windows Phone)/.test(ua),
      symbian = /(?:SymbianOS)/.test(ua) || windowsPhone,
      android = /(?:Android)/.test(ua),
      fireFox = /(?:Firefox)/.test(ua),
      chrome = /(?:Chrome|CriOS)/.test(ua),
      weChat = ua.indexOf('MicroMessenger') > -1,
      qq = ua.indexOf('QQ') > -1,
      tablet = /(?:iPad|PlayBook)/.test(ua) || (android && !/(?:Mobile)/.test(ua)) || (fireFox && /(?:Tablet)/.test(ua)),
      iPad = /(?:iPad)/.test(ua),
      pad = /(?:pad)/.test(ua),
      phone = /(?:iPhone)/.test(ua) && !tablet,
      mobile = !!ua.match(/AppleWebKit.*Mobile.*/),
      ios = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      pc = !phone && !android && !symbian,
      webview = !chrome && ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
      mfhApp = ua.indexOf(APP_HEAD_PROTOCOL) > -1 || ua.indexOf(APP_HEAD_PROTOCOL_2) > -1

    return { tablet, phone, android, pc, pad, iPad, ios, chrome, webview, mobile, weChat, qq, mfhApp }
  },

  // 获取平台版本号
  getPlatformVersion(platform){
    let version
    let reg = new RegExp("\\b" + platform + "\/(\\S*)")
    let platformString = navigator.userAgent.toString().match(reg)
    version = platformString ? platformString[1] : ''

    return version
  },

  // 当前页面分享设置
  wxShare (WxSignature, shareDesc) {
    let {title, desc, link, imgUrl, type, dataUrl} = shareDesc

    let currentUrl = location.href

    wx.config({
      debug: false,                     // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: WxSignature.appId,         // 必填，公众号的唯一标识
      timestamp: WxSignature.timestamp, // 必填，生成签名的时间戳
      nonceStr: WxSignature.nonceStr,   // 必填，生成签名的随机串
      signature: WxSignature.signature, // 必填，签名，见附录1
      url: currentUrl,
      jsApiList: [                      // 必填，需要使用的JS接口列表
        // "checkJsApi",
        'onMenuShareTimeline',          // 分享到微信朋友圈
        'onMenuShareAppMessage',        // 分享给微信朋友
        // 'onMenuShareQQ',                // 分享到QQ
        // 'onMenuShareQZone',             // 分享到QQ空间
        "updateAppMessageShareData",    // 分享到微信及QQ（新接口）
        "updateTimelineShareData",      // 分享到朋友圈”及“分享到QQ空间（新接口）
        // 'getLocation',                  //
      ]
    })

    wx.error(function(res){
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      console.log('微信分享config信息验证失败', res)
    })

    wx.ready(function () {

      shareDesc.imgUrl = imgDomain + shareDesc.imgUrl
      shareDesc.link = appDomain + shareDesc.link

      console.log('微信分享', shareDesc)

      /*wx.updateTimelineShareData({
        title: title,                       // 分享标题
        link: link,                         // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl,                     // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
          console.log("分享成功")
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
          console.log("分享失败")
        }
      })*/
      /*wx.updateAppMessageShareData({
        title: title,                      // 分享标题
        desc: desc,                        // 分享描述
        link: link,                        // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl,                    // 分享图标
        // type: type || 'link',              // 分享类型,music、video或link，不填默认为link
        // dataUrl: dataUrl || '',            // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户确认分享后执行的回调函数
          console.log("分享成功")
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
          console.log("分享失败")
        }
      })*/
      wx.onMenuShareAppMessage({
        title: title,                      // 分享标题
        desc: desc,                        // 分享描述
        link: link,                        // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl,                    // 分享图标
        // type: type || 'link',                  // 分享类型,music、video或link，不填默认为link
        // dataUrl: dataUrl || '',            // 如果type是music或video，则要提供数据链接，默认为空
        success() {
          // 用户确认分享后执行的回调函数
          console.log("分享成功")
        }
      })
    })

  },

  // 配置微信API
  setWxConfig(WxSignature, apis){
    let currentUrl = location.href

    console.log('微信信息配置2', WxSignature)

    wx.config({
      debug: false,                     // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: WxSignature.appId,         // 必填，公众号的唯一标识
      timestamp: WxSignature.timestamp, // 必填，生成签名的时间戳
      nonceStr: WxSignature.nonceStr,   // 必填，生成签名的随机串
      signature: WxSignature.signature, // 必填，签名，见附录1
      url: currentUrl,
      jsApiList: [                      // 必填，需要使用的JS接口列表
        ...apis                          //
      ]
    })

  },

  // 微信获取地址
  wxGetLocation: async (callback) => {

    let {data} = await getWxJsSdkConfig()

    console.log('微信信息配置', data)

    let {code, message} = data

    if(code == 200){

      let {config} = data.data

      let currentUrl = location.href

      wx.config({
        debug: false,                     // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: config.appId,              // 必填，公众号的唯一标识
        timestamp: config.timestamp,      // 必填，生成签名的时间戳
        nonceStr: config.nonceStr,        // 必填，生成签名的随机串
        signature: config.signature,      // 必填，签名，见附录1
        url: currentUrl,
        jsApiList: ['chooseWXPay']        // 必填，需要使用的JS接口列表
      })

      wx.checkJsApi({
        jsApiList: ['getLocation'],
        success: function (res) {
          if (!res.checkResult.getLocation) {
            alert('你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！')
          }
        }
      })

      wx.ready(function () {
        wx.getLocation({
          type: 'wgs84',                   // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            // res.latitude   // 纬度，浮点数，范围为90 ~ -90
            // res.longitude  // 经度，浮点数，范围为180 ~ -180
            // res.speed      // 速度，以米/每秒计
            // res.accuracy   // 位置精度

            // console.log('位置信息(fromWechatApi)', res)

            callback && callback(res)
          },
          cancel: function (res) {
            console.log('微信用户拒绝授权获取地理位置')
            callback && callback()
          },
          fail: function (res) {
            console.log('微信定位失败', res)
            callback && callback()
          },
        })
      })

      wx.error(function (res) { console.log('微信定位出错(fromJsapi)', res) })

    } else {
      this.$uihelper.toast(message)
    }

  },


  // 获取cookic中cname
  getCookie(cname){
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  },

  // 保存cname的值到cookic
  setCookie (cname, cvalue) {
    let d = new Date();
    let exdays=7;
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  },

  // 获取URL中参数值
  getQueryString(name){
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null)return unescape(r[2]);
    return null;
  },
  getURLQueryString(url, name){
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
    var r = url.slice(url.indexOf('?')+1).match(reg)
    if (r != null)return unescape(r[2])
    return null;
  },

  // 删除url中某个参数,并跳转
  delQueryString(name){
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname + "?";
    var query = loca.search.substr(1);
    if (query.indexOf(name) > -1) {
      var obj = {}
      var arr = query.split("&");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=");
        obj[arr[i][0]] = arr[i][1];
      }
      delete obj[name];
      var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
      return url
    }
  },
  delUrlQS(url, name){
    let urlParts = url.split('?')
    if(urlParts.length >= 2) {
      //参数名前缀
      let prefix = encodeURIComponent(name) + '='
      let pars = urlParts[1].split(/[&;]/g)

      //循环查找匹配参数
      for(let i = pars.length; i-- > 0;) {
        if(pars[i].lastIndexOf(prefix, 0) !== -1) {
          //存在则删除
          pars.splice(i, 1)
        }
      }
      return urlParts[0] + (pars.length > 0 ? '?' + pars.join('&') : '')
    }
    return url
  },

  /**
   * 更新/追加url参数 (update URL QueryString)
   * @Param {String} url - 原url地址
   * @Param {String} key - 参数名
   * @Param {} val - 参数值
   * */
  updateUrlQS(url, key, val) {
    let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i")
    let separator = url.indexOf('?') !== -1 ? "&" : "?"
    return url.match(re) ? url.replace(re, '$1' + key + "=" + val + '$2') : url + separator + key + "=" + val
  },

  // 验证手机号码
  checkPhone(mobile) {
    return (/^1[34578]\d{9}$/.test(mobile))
    // if (!(/^1[34578]\d{9}$/.test(mobile))) {
    //   return false;
    // }
  },

  // 转换时间格式yyyy-MM-dd h:m:s
  getTime(timestamp, type){
    var newDate = new Date();
    newDate.setTime(timestamp * 1000);
    Date.prototype.format = function (format) {
      var date = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S+": this.getMilliseconds()
      };
      if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (var k in date) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
        }
      }
      return format;
    }
    if (type === "detail") {
      return newDate.format('yyyy-MM-dd hh:mm:ss')
    } else {
      return newDate.format('yyyy-MM-dd')
    }
  },

  // 转换时间格式yyyy-MM-dd h:m:s (没有除以1000)
  getTimeStr(timestamp, format='yyyy-MM-dd hh:mm:ss'){

    let newDate = new Date()
    newDate.setTime(timestamp)

    Date.prototype.format = function (format) {
      let date = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S+": this.getMilliseconds()
      }
      if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in date) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length))
        }
      }
      return format
    }

    return newDate.format(format)

  },

  /**
   * 加减时间(Date)
   * @param {{hour: number}} param - 调整时间参数
   * @param {date} param.date - Date对象，默认当前时间
   * @param {number} param.year - 年，整数，正数表示加多少年，负数表示减多少年(下同)
   * @param {number} param.month - 月
   * @param {number} param.day - 日
   * @param {number} param.hour - 时
   * @param {number} param.min - 分
   * @param {number} param.sec - 秒
   * @return {Date} date - 返回调整过的Date对象
   * */
  adjustTime(param){
    let {date, year, month, day, hour, min, sec} = param

    date = date ? new Date(date) : new Date()

    if(year) date.setYear(date.getFullYear() + year)
    if(month) date.setMonth(date.getMonth() + month)
    if(day) date.setDate(date.getDate() + day)
    if(hour) date.setHours(date.getHours() + hour)
    if(min) date.setMinutes(date.getMinutes() + min)
    if(sec) date.setSeconds(date.getSeconds() + sec)

    return date

  },

  /**
   * 分离整数小数
   * @param {Number|String} num - 数值或者数字字符
   *
   * @return {Object} result - 返回值
   * @property {String} result.integer - 整数部分
   * @property {String} result.decimal - 小数部分
   * */
  splitDec(num){
    let result = num.toString().match(/(-?[0-9]*)\.?([0-9]*)/)
    return { integer: result[1], decimal: result[2] }
  },

  /**
   * 打开APP, 没有就下载
   * @param {String | Number} isInside - 是否是APP内部页
   * @param {String} path=['event'|'groupDetail'] - APP页面
   * @param {boolean} wechatToBrowser - 是否微信内引导到浏览器
   * */
  openApp(isInside, path, wechatToBrowser) {


    if(this.getPlatform().weChat){

      // 打开“去浏览器操作”提醒
      if(wechatToBrowser){
        return true
      }

      // 微信内不打开APP 直接进行下一步操作
      return false
    }

    isInside = +isInside

    if (isInside) return false

    let scheme
    let fullPath = location.href
    let param = ''

    if(path === 'event'){
      let url = this.updateUrlQS(fullPath, 'is_mine', '0')
      url = this.updateUrlQS(url, 'is_inside', '1')
      url = encodeURIComponent(url)

      let activity_id_param = '&activity_id=' + this.getURLQueryString(fullPath,'activity_id')
      param = `&url=${url}` + (activity_id_param || '')
    }

    switch (this.getEnv()){
      case 'web':
        break
      case 'android':
        scheme = 'scheme://mofanghouse:8080/init'
        location.href = `${scheme}?path=${path}` + param
        break
      case 'ios':
        scheme = 'h5-mofanghouse://init'
        location.href = `${scheme}?path=${path}` + param
        break
    }

    setTimeout(()=>{
      this.$uihelper.toast('您还未下载APP')
    }, 1000)

    setTimeout(()=>{
      location.href = 'https://www.mofanghouse.com'
    }, 1500)

    return true
  },

  // 去除市、自治区等
  getSimplifyAddrName(addrStr){
    if(!addrStr) return
    addrStr = addrStr.replace(/(.+)[藏|壮|傣]族.{1,2}族自治州/g, "$1")
    addrStr = addrStr.replace(/(.+)((.{2}族.{1,2}族)|蒙古)自治州/g, "$1")
    addrStr = addrStr.replace(/(.+)[回|藏|藏|彝|傣|白]族自治州/g, "$1")
    addrStr = addrStr.replace(/(.+)(.{2}族)自治州/g, "$1")
    addrStr = addrStr.replace(/(.{2,10})市/g, "$1")
    addrStr = addrStr.replace(/地区|自治州/g, "")
    return addrStr
  },


  // --- 测试 ---

  // todo 后台返回数据有误，处理返回数据
  dealWithErrorDate(data) {
    if(typeof data === 'string'){
      return JSON.parse(data.substr(data.indexOf('}{')+1))
    }else{
      return data
    }
  },


}
